import React, { Component, Suspense } from "react";
import { I18n } from "react-redux-i18n";
import Modal from "@alboompro/boom-components/data-display/modal";
import Button from "@alboompro/boom-components/general/button";
import Icon from "@alboompro/boom-components/general/icon";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import { PropListItem, PropLabel } from "./styles";

const CustomPropListItem = styled(PropListItem)`
  flex-direction: column;
`;

const CustomPropLabel = styled(PropLabel)`
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2px;
`;

const CodeContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 150px;
  border: 1px solid #ebebeb;
  border-radius: 3px;

  .ace_editor {
    width: calc(100% - 2px) !important;
    height: calc(100% - 2px) !important;
    margin: auto;
    transform: translateY(1px);
  }

  .ace_focus{
    box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
  }
`;

export const EditorContent = styled.div`
  height: 100%;
  overflow: auto;
  * {
    font-family: monospace !important;
  }
`;

const CodeHeader = styled.div`
  display: flex;
  align-items: center;
  background-color: #ededed;
  padding: 3px 5px;
  font-size: 10px;
  color: #878787;
`;

const ExpandButton = styled.div`
  cursor: pointer;
  margin-left: auto;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  
  button {
    &:not(:last-child) {
      margin-right: 15px;
    }
  }

  * {
    font-size: 14px;
  }
`;

const ModalAceEditor = styled.div`
  height: 500px;
  .ace_editor * {
    font-family: monospace !important;
  }
`;

const LoadingCode = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// const HandleEditor = React.lazy(() => import("./AceEditor"));

const AceEditorLoad = React.lazy(() => import("./AceEditor"));

class GenericElement extends Component {
  state = {
    modalStatus: false,
  };

  handleModal = () => {
    const { modalStatus } = this.state;
    this.setState({ modalStatus: !modalStatus });
  };

  handleChange = (value) => {
    const { updaterFn, name } = this.props;
    updaterFn({ prop: name, value });
    // this.setState({ htmlCode: value });
  };

  loadHandler = () => (
    <LoadingCode>
      <svg
        width="25px"
        height="25px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="#B5B5B5"
          strokeWidth="10"
          r="35"
          strokeDasharray="164.93361431346415 56.97787143782138"
          transform="rotate(215.545 50 50)"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            calcMode="linear"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
            dur="1s"
            begin="0s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </LoadingCode>
  );

  render() {
    const { modalStatus } = this.state;
    const {
      currentValue,
      label,
      locale,
      language,
      placeholder,
      theme,
      tooltip,
    } = this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    return [
      <CustomPropListItem>
        <CustomPropLabel>
          <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
        </CustomPropLabel>
        <CodeContent>
          <Suspense fallback={this.loadHandler()}>
            <CodeHeader>
              {currentValue.length} {I18n.t("editPanel.codeEditor.characters")}
              <ExpandButton onClick={this.handleModal}>
                <Icon
                  kind="bold"
                  group="interface-essential"
                  category="expand-retract"
                  file="expand-5.svg"
                  size="12"
                  color="#8B8B8B"
                />
              </ExpandButton>
            </CodeHeader>
            <EditorContent>
              <AceEditorLoad
                htmlCode={currentValue}
                onChange={this.handleChange}
                mode={language}
                placeholder={placeholder[locale]}
                theme={theme}
                aceEditorOptions={{
                  tabSize: 2,
                  showGutter: false,
                }}
              />
            </EditorContent>
          </Suspense>
        </CodeContent>
      </CustomPropListItem>,
      <Modal
        title={label[locale]}
        visible={modalStatus}
        onClose={this.handleModal}
        backdropClosable={false}
        width={800}
        footer={
          <ModalFooter>
            <Button onClick={this.handleModal} style={{ backgroundColor: "transparent" }}>
              {I18n.t("general.cancel")}
            </Button>
            <Button onClick={this.handleModal} type="primary" style={{ backgroundColor: "#44adf8"}}>
              {I18n.t("general.save")}
            </Button>
          </ModalFooter>
        }
      >
        <ModalAceEditor>
          <AceEditorLoad
            htmlCode={currentValue}
            onChange={this.handleChange}
            mode={language}
            placeholder={placeholder[locale]}
            theme={theme}
          />
        </ModalAceEditor>
      </Modal>,
    ];
  }
}

export default GenericElement;
